import barba from '@barba/core'
import { delay, paginationControls } from '../components/utils'
import { cluesInit } from '../components/clue'
import {
    setStoreQuestionValue,
    getStoreQuestionValue,
} from '../components/stores'
import { audio } from '../components/audio'
import { bubbles } from '../components/bubbles'
import { dictionary } from '../components/dictionary'
import { navigationButtonsCallback } from '../components/navigationCallback'

const rotary_8 = () => {
    delay(500).then(() => {
        if (isDebugMode) {
            console.log('Rotary Q8: Loaded')
        }

        // --------------------------------------------------
        // ELEMENTS
        // --------------------------------------------------
        let textarea = document.querySelector('#answer_1')
        let textarea2 = document.querySelector('#answer_2')

        // --------------------------------------------------
        // QUESTION
        // --------------------------------------------------
        let questionIndex = 8
        let questionPart = 0
        let questionPart2 = 1

        // --------------------------------------------------
        // METHODS
        // --------------------------------------------------
        paginationControls(questionIndex)
        cluesInit()
        bubbles()
        audio()
        dictionary()

        // --------------------------------------------------
        // STORAGE
        // --------------------------------------------------

        // GET localStorage and render on the frontend
        let storedValue = getStoreQuestionValue(
            'assessment',
            'questions',
            questionIndex,
            questionPart
        )
        if (storedValue) {
            textarea.value = storedValue
        }
        let storedValue2 = getStoreQuestionValue(
            'assessment',
            'questions',
            questionIndex,
            questionPart2
        )
        if (storedValue2) {
            textarea2.value = storedValue2
        }

        // SET localStorage values for this question
        const setLocalStorage = () => {
            setStoreQuestionValue(
                'assessment',
                'questions',
                questionIndex,
                questionPart,
                textarea.value
            )
            setStoreQuestionValue(
                'assessment',
                'questions',
                questionIndex,
                questionPart2,
                textarea2.value
            )
        }

        // --------------------------------------------------
        // NAVIGATION
        // --------------------------------------------------
        navigationButtonsCallback(setLocalStorage)
    })
}

export { rotary_8 }
